import { Modal } from '../../components/Modal/Modal'
import React, { useState } from 'react'
import { logout } from '../../store/auth/authSlice'
import { useAppDispatch } from '../../store/hooks'
import { useNavigate } from 'react-router-dom'
import { handleCompanySsoLogout } from '../../common/companySso'

export const Logout = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [showLogoutModal, setShowLogoutModal] = useState(true)
  const onCancel = () => {
    setShowLogoutModal(false)
    navigate('/')
  }

  const logoutModalBody = <>Are you sure you want to log out?</>

  const handleLogout = () => {
    setShowLogoutModal(false)
    handleCompanySsoLogout()
    dispatch(logout({}))
  }
  return (
    <>
      <Modal
        show={showLogoutModal}
        onHide={onCancel}
        header={<></>}
        body={logoutModalBody}
        showFooterActions={true}
        onFooterPrimaryAction={handleLogout}
        footerPrimaryActionTitle='Log out'
        footerSecondaryActionTitle='Cancel'
        centered={true}
      />
    </>
  )
}
